const normalizePhone = x => {
  x = x.replace(/\D+/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  return x;
};

export default normalizePhone;
